// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2qATI","inner":"Footer_inner__2PV_q"};